const User = {
    userId: "userId",// 用户id
    realName: "realName",// 用户真实姓名
    headUrl: "headUrl",//用户头像
    userName: "userName", // 登录用户名
    Authentication: "Authenticationdls", // 个人凭证
    identity:"identity",
    roles: "roles", // 角色
    authoritys: "authoritys", // 个人权限
    menus: "menus", // 菜单
    pass: "password"
}

const RespCode = {
    success: 200, // 通过
    fail: "0001", // 失败
    noAuthority: "0002", // 没权限
    exception: "0003", // 异常
    needLogin: 401, // 凭证失效
}

const editorConfig = {
    toolbars: [[
        'undo', 'redo', '|',
        'bold', 'italic', 'underline', 'fontborder', 'strikethrough',
        'superscript', 'subscript', 'removeformat', 'formatmatch', '|',
        'forecolor', 'backcolor', 'insertorderedlist', 'insertunorderedlist', '|',
        'rowspacingtop', 'rowspacingbottom', 'lineheight', '|',
        'customstyle', 'paragraph', 'fontfamily', 'fontsize', '|',
        'indent', 'justifyleft', 'justifycenter', 'justifyright', 'justifyjustify', '|',
        'touppercase', 'tolowercase', '|', 'link', 'unlink', '|',
        'imagenone', 'imageleft', 'imageright', 'imagecenter', '|',
        'simpleupload', 'insertimage', 'insertvideo', 'music', 'attachment',
        'horizontal', 'spechars', '|',
        'inserttable', 'insertparagraphbeforetable', 'insertrow',
        'deleterow', 'insertcol', 'deletecol', 'mergecells', 'mergeright',
        'mergedown', 'splittocells', 'splittorows', 'splittocols', '|',
        'searchreplace'
    ]]
}

export default {
    User,
    RespCode,
    editorConfig,
}


// WEBPACK FOOTER //
// ./src/utils/commons.js